// Shared constants for the application

// Storage keys
export const STORAGE_KEYS = {
  USER_SESSION: 'yolal-user-session',
  LOCALE: 'locale',
  ENCRYPTED_LOCALE: 'encryptedLocale',
  IMAGE_CACHE_PREFIX: 'img_cache_'
}

// API endpoints
export const API_ENDPOINTS = {
  LOGIN: '/api/auth/login',
  LOGOUT: '/api/auth/logout',
  REFRESH_TOKEN: '/api/auth/refresh'
}

// Token expiration (in milliseconds)
export const TOKEN_EXPIRY = {
  ACCESS_TOKEN: 24 * 60 * 60 * 1000, // 24 hours
  REFRESH_TOKEN: 7 * 24 * 60 * 60 * 1000 // 7 days
}

// Image cache settings
export const IMAGE_CACHE = {
  DEFAULT_EXPIRY: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
  PREFIX: 'img_cache_'
}